import styled from 'styled-components';
import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';

const SliderImageAnimationLess = styled.img<React.CSSProperties>`
  border-radius: ${30 * Screen.widthRatio}px;
  height: ${428 * Screen.widthRatio}px;
  position: absolute;
  width: ${760 * Screen.widthRatio}px;
`;

SliderImageAnimationLess.defaultProps = {
  src: PhotoDefault,
};

export default SliderImageAnimationLess;
